export default __webpack_public_path__ + "static/media/goal.eb718a16.svg";